import axios from 'axios';

const cielo = axios.create({
  baseURL: 'https://cieloecommerce.cielo.com.br/api/public',
});

export default cielo;
